







































































































































































































import Vue, { PropType } from "vue";
import { OrderInformationInterface } from "@/model/components/OrderInformationInterface.ts";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { tel, zipcode } from "@/model/validators/";
import YubinBango from "yubinbango.js";
import { zenkakuToHankaku } from "@/model/replacer/zenkakuToHankaku";

export default Vue.extend({
  name: "OrderInformation",

  mixins: [validationMixin],

  props: {
    orderInformation: {
      type: Object as PropType<OrderInformationInterface>
    },
    category: {
      type: String as PropType<"repeat" | "manuscript" | "inquiry">
    }
  },

  validations() {
    let validations = {
      name: { required },
      kana: {},
      company: {},
      zipcode: {},
      address: {},
      tel: { required, tel },
      email: { required, email }
    };

    if (this.isAddressShow) {
      validations = {
        ...validations,
        ...{
          zipcode: { required, zipcode },
          address: { required }
        }
      };
    }

    return validations;
  },

  computed: {
    name(): string {
      return this.orderInformation.name;
    },
    kana(): string {
      return this.orderInformation.kana;
    },
    company(): string {
      return this.orderInformation.company;
    },
    zipcode(): string {
      return this.orderInformation.zipcode;
    },
    address(): string {
      return this.orderInformation.address;
    },
    tel(): string {
      return this.orderInformation.tel;
    },
    email(): string {
      return this.orderInformation.email;
    },
    isAddressShow(): boolean {
      // ご住所欄はデータ入稿フォームのみ
      return this.category === "manuscript";
    }
  },

  methods: {
    updateOrderInformation(value: string, label: string): void {
      this.$v[label].$touch();
      this.$emit(
        "updateOrderInformation",
        Object.assign({}, this.orderInformation, { [label]: value })
      );
    },
    autoComplete(): void {
      if (this.zipcode.length >= 7) {
        YubinBango.getAddress(this.zipcode).then(res => {
          let address = res.prefecture + res.locality + res.street;
          if (res.extended) {
            address = address + res.extended;
          }
          this.$emit(
            "updateOrderInformation",
            Object.assign({}, this.orderInformation, { address: address })
          );
        });
      }
    },
    openModalBtnClick(): void {
      this.$emit("openModalBtnClick");
    },
    zenkakuToHankaku
  }
});
